import Ajax from '@utils/ajax';

export default {
  fetch(page, filter = null) {
    let url = `/user_notifications?page=${page}`;
    if (filter) {
      url += `&filter=${filter}`;
    }

    return Ajax.get({
      url: url,
    });
  },

  follows(page) {
    return Ajax.get({
      url: `/user_notifications/follows?page=${page}`,
    });
  },

  markSelectedAsClicked(ids) {
    return Ajax.post({
      url: `/user_notifications/mark_selected_as_clicked`,
      data: {
        ids: ids,
      },
    });
  },

  markAllAsSeen(filter = null) {
    let url = `/user_notifications/mark_all_as_seen`;
    if (filter) {
      url += `?filter=${filter}`;
    }
    return Ajax.post({
      url: url,
    });
  },

  markClicked(n) {
    return Ajax.post({
      url: `/user_notifications/${n.id}/mark_clicked`,
    });
  },

  createAndMarkClicked(n) {
    return Ajax.post({
      url: `/user_notifications/create_and_mark_clicked`,
      data: {
        notification_id: n.notification_id,
      },
    });
  },
};
